import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import {incrementLayerCounter, decrementLayerCounter} from '../../../view/cmn/docAutomation/formFunctions';
import SarasDialog from '../../container/popup/SarasDialogDefAction';
import SarasModal from '../../container/popup/SarasModal';
import useDeviceDetection from '../../hooks/deviceIntegration/useDeviceDetection';

const FormDialog = (props) => {
    const { dynamicViewData, onDynamicViewClose, formObject, 
        enablePopup, action, children, formStyle, contentStyle, 
        formTitle, onPopupClose,
        rowKey, headerKey, attachData, ...restProps } = props;
    const [formActions, setFormActions] = React.useState({});
    const [open, setOpen] = React.useState(true);
    // const [currentLayer, setCurrentLayer] = React.useState();

    const deviceInfo = useDeviceDetection();

    var disableActionState = useSelector(state => state.formState);
    var disableFormActions = false;

    if (disableActionState != null){
        // console.log("form action button read", formObject.formStateKey, disableActionState, disableActionState[formObject.formStateKey] ? true : false);
        disableFormActions = disableActionState[formObject.formStateKey] ? true : false;
    }

    const initModel = () => {
        // setOpen(enablePopup)

        if(enablePopup){
            // console.log("current layer formdialog before increment", getCurrentLayer());

            incrementLayerCounter();

            // console.log("current layer formdialog after increment", getCurrentLayer());

            // setCurrentLayer(getCurrentLayer());
        }
    }

    useEffect(initModel, [enablePopup])

    const onAction = (e) => {
        // console.log("action clicked");
        //fire form action with action id = save
        let saveAction = {isDialog: true, closeOnAction: action.closeOnAction, 
            actionMessage: action.actionMessage || "PleaseWait", actionId: action.actionId 
                || "save", actionParam: {}, containerKey:"", 
            onSuccess: onSuccess, onError: onError, onCleanup: onCleanup};
        
        if(action.actionParam){
            saveAction["actionParam"] = {...action.actionParam};
        }

        formObject.onFormAction(saveAction, rowKey, headerKey, attachData);
    }

    const onCancel = (e) => {
        // console.log("cancel clicked");
        //fire form action with action id = cancel
        let cancelAction = {isDialog: true, actionId: "cancel", 
            actionParam: {}, containerKey:"", 
            onSuccess: onSuccess, onError: onError, onCleanup: onCleanup };

        if(action.actionParam){
            cancelAction["actionParam"] = {...action.actionParam};
        }

        formObject.onFormAction(cancelAction, rowKey, headerKey, attachData);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        // console.log("action was successfully executed, hence close the form");
        if(action.closeOnAction === undefined || action.closeOnAction !== false)
        {
            onModalClose();
        }
    }

    const onError = (action, containerKey, rowKey, headerKey, response) => {
        // console.log("action was executed with, hence keep the form open");
        //do any other action here if required
        //TODO display error
    }

    const onClose = (e) => {
        onModalClose(e);
    }

    const onModalClose = (e) => {
        if(onPopupClose) onPopupClose();
        //formRefreshCode on cancel click ( Manish )
        formObject.refreshDependentForms(action);
        onCleanup(e);
    }

    const onCleanup = (e) => {
        setOpen(false);

        if(onDynamicViewClose) onDynamicViewClose(e, dynamicViewData);

        decrementLayerCounter();
    }
    
    const initFormDialog = () => {
        if(enablePopup && (action && action.formActions)){

            let actionObject = {};

            if(action.formActions.forAction){
                actionObject["actionFunction"] = action.formActions.actionFunction || onAction;
                actionObject["actionName"] = action.formActions.forAction;
                actionObject["confirmAction"] = action.formActions.confirmAction;
                actionObject["actionKSC"] = "save";
            }

            if(action.formActions.forCancel){
                actionObject["cancelFunction"] = action.formActions.cancelFunction || onCancel;
                actionObject["cancelName"] = action.formActions.forCancel;
                actionObject["confirmCancel"] = action.formActions.confirmCancel;
                actionObject["cancelKSC"] = "cancel";
            }

            if(action.formActions.forClose){
                actionObject["closeFunction"] = onClose;
                actionObject["closeName"] = action.formActions.forClose;
                actionObject["confirmClose"] = action.formActions.confirmClose;
                // actionObject["closeKSC"] = "esc";
            }

            setFormActions(actionObject);
        }
    }

    useEffect(initFormDialog, [action]);

    if(enablePopup){
        return (
            <SarasModal enableModal={true} modelState={true} onModalClose={onClose} >
            <SarasDialog disableFormActions={disableFormActions} open={open} 
                formStyle={{...formStyle, height: deviceInfo.activateMobileView ? '90dvh' : formStyle && formStyle.height, maxWidth: "90vw"}} 
                contentStyle={contentStyle} title={formTitle || ''} 
                {...formActions} 
                {...restProps}>
                {
                    children
                }
            </SarasDialog>
            </SarasModal>
        )
    }
    else {
        return (
            children
        )
    }
}

export default FormDialog